enum Token {
  CONTENT_CLIENT = 'CONTENT_CLIENT',
  MAIN_CLIENT = 'MAIN_CLIENT',
  TOKENS_MANAGER = 'TOKENS_MANAGER',
  CONTENT_API = 'API',
  MAIN_API = 'API',
  ACTIVITY_SERVICE = 'ACTIVITY_SERVICE',
  ACTIVITY_GROUP_SERVICE = 'ACTIVITY_GROUP_SERVICE',
  ACTIVITY_GROUP_ACTIVITY_SERVICE = 'ACTIVITY_GROUP_ACTIVITY_SERVICE',
  MEDIA_GROUP_SERVICE = 'MEDIA_GROUP_SERVICE',
  MEDIA_SERVICE = 'MEDIA_SERVICE',
  ROOM_SERVICE = 'ROOM_SERVICE',
  ROOM_ACTIVITY_SERVICE = 'ROOM_ACTIVITY_SERVICE',
  ROOM_TO_ACTIVITY_GROUP_SERVICE = 'ROOM_TO_ACTIVITY_GROUP_SERVICE',
  TAG_SERVICE = 'TAG_SERVICE',
  AUTH_SERVICE = 'AUTH_SERVICE',
  WORKSPACE_SERVICE = 'WORKSPACE_SERVICE',
}

export default Token
